exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n\r\n  .example-full-width {\r\n    display:flow-root;\r\n  }\r\n\r\n  /* ignore parent width */\r\n  .mat-form-field{\r\n    width:100%;\r\n    padding:5px 10px 5px 10px;\r\n  }\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/LenninM/WebstormProjects/NomisignWebApp/src/app/components/securityquestions/securityquestions.component.css
// module id = ../../../../../src/app/components/securityquestions/securityquestions.component.css
// module chunks = main